import { render, staticRenderFns } from "./ProviderFilters.vue?vue&type=template&id=2485c74a"
import script from "./ProviderFilters.vue?vue&type=script&lang=js"
export * from "./ProviderFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports